module.exports = __webpack_public_path__ + "img/mall_img_miaosha_bl@3x.06858d46.png";